const contactData = {
    lineID: "@cozyscape",
    phone: "093-429-1935,090-951-4222",
    facebook: "https://www.facebook.com/cozyscapeofficial",
    youtube: "https://www.youtube.com/@cozyscapeofficial",
    tiktok: "https://www.tiktok.com/@cozyscapeofficial"
};

export default contactData;

